;(function(w){
	function Footer(){
		var self = this;
		this.main = document.getElementById('footer');

		var facebook_btn = $(this.main).find('.facebook_btn')[0];
		var twitter_btn = $(this.main).find('.twitter_btn')[0];


		$(facebook_btn).bind('click', onClickFacebookBtn);
		$(twitter_btn).bind('click', onClickTwitterBtn);
		$(this.main).find('.link-home a').bind('click', onClickInicioBtn);

		this.mostrar = function(sin_inicio){
			if(typeof sin_inicio == 'undefined'){
				sin_inicio = false;
			}

			if(sin_inicio){
				$(self.main).addClass('sin-inicio');
			}

			$(self.main).addClass('active');
		}

		this.ocultar = function(){
			$(self.main).removeClass('active');
			$(self.main).removeClass('sin-inicio');
		}

		function onClickFacebookBtn(e){
			e.preventDefault();
			
			ga('send', {hitType: 'event', eventCategory: 'Share',  eventAction: 'Click', eventLabel: 'Facebook'});
			
			window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(WEB_PATH), 'fbShareWindow', 'height=600, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
		}

		function onClickTwitterBtn(e){
			e.preventDefault();
			
			ga('send', {hitType: 'event', eventCategory: 'Share',  eventAction: 'Click', eventLabel: 'Twitter'});

			window.open('https://twitter.com/intent/tweet?text='+encodeURIComponent('Los caminos de Oscar López, especial multimedia. @ElNuevoDia.')+'&url='+encodeURIComponent(WEB_PATH), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
		}

		function onClickInicioBtn(e){
			ga('send', {hitType: 'event', eventCategory: 'Inicio',  eventAction: 'Click', eventLabel: 'Boton Inicio'});
		}
	}
	
	w.Footer = Footer;
})(window)